import React, { useState } from "react";
import { FiPrinter } from "react-icons/fi";

import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";

import RepresentativeSettlementPage from "./RepresentativeSettlementPage";
import PaymentMethods from "./PaymentMethods";

import "./RepresentativeSettlement.css";

const RepresentativeSettlement = () => {
  const [selectedRepresentative, setSelectedRepresentative] =
    useState(null);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [dailyData, setDailyData] = useState(null);

  const [refreshKey, setRefreshKey] = useState(0);

  /* =========================================================
     SELECT REPRESENTATIVE
  ========================================================= */

  const handleSelectRepresentative = (representative) => {
    setSelectedRepresentative(representative);
    setDailyData(null);
  };

  /* =========================================================
     DATE CHANGE
  ========================================================= */

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setDailyData(null);
  };

  /* =========================================================
     DAILY DATA
  ========================================================= */

  const handleDataLoaded = (data) => {
    setDailyData(data);
  };

  /* =========================================================
     AFTER SETTLEMENT SAVE
  ========================================================= */

  const handleSettlementSaved = () => {
    setRefreshKey((previous) => previous + 1);
  };

  /* =========================================================
     PRINT
  ========================================================= */

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="representative-page">

      {/* =====================================================
          SIDEBAR
      ===================================================== */}

      <div className="representative-sidebar no-print">
        <Sidebar />
      </div>

      {/* =====================================================
          PAGE BODY
      ===================================================== */}

      <div className="representative-body">

        {/* ===================================================
            HEADER
        =================================================== */}

        <div className="representative-header no-print">
          <Header />
        </div>

        {/* ===================================================
            MAIN
        =================================================== */}

        <main className="representative-main">

          {/* =================================================
              PRINT AREA
          ================================================= */}

          <div className="representative-print-area">

            {/* ===============================================
                REPORT
            =============================================== */}

            <RepresentativeSettlementPage
              selectedRepresentative={
                selectedRepresentative
              }
              onSelectRepresentative={
                handleSelectRepresentative
              }
              selectedDate={selectedDate}
              onDateChange={handleDateChange}
              onDataLoaded={handleDataLoaded}
              refreshKey={refreshKey}
            />

            {/* ===============================================
                SETTLEMENT
            =============================================== */}

            {selectedRepresentative && dailyData && (
              <PaymentMethods
                selectedRepresentative={
                  selectedRepresentative
                }
                dailyData={dailyData}
                onSaved={handleSettlementSaved}
                date={selectedDate}
              />
            )}

          </div>

          {/* =================================================
              PRINT BUTTON
          ================================================= */}

          {selectedRepresentative && dailyData && (
            <div className="print-action no-print">

              <button
                type="button"
                onClick={handlePrint}
                className="print-button"
              >
                <FiPrinter size={17} />

                <span>
                  طباعة كشف الحساب
                </span>
              </button>

            </div>
          )}

        </main>
      </div>
    </div>
  );
};

export default RepresentativeSettlement;